var map = {
	"./1/title-banner1-type1.png": "IPqq",
	"./2/title-banner1-type1.png": "Nx7Y",
	"./3/title-banner1-type1.png": "FFLg",
	"./4/title-banner1-type1.png": "nMVq",
	"./5/title-banner1-type1.png": "GYyT",
	"./6/title-banner1-type1.png": "9KSa",
	"./7/title-banner1-type1.png": "UPsY",
	"./8/title-banner1-type1.png": "Egjv"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "D/4M";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs ^\.\/.*\/title\-banner1\-type1\.png$
// module id = D/4M
// module chunks = 1